export const formatDateTime = (datetime: Date) : string => {
  if (!(datetime instanceof Date)) return ''
  let year = datetime.getFullYear(),
    month = datetime.getMonth() + 1,
    date = datetime.getDate(),
    hour = datetime.getHours(),
    minute = datetime.getMinutes(),
    second = datetime.getSeconds()
  return `${year}-${('00' + month).substr(-2)}-${('00' + date).substr(-2)} ${('00' + hour).substr(-2)}:${('00' + minute).substr(-2)}:${('00' + second).substr(-2)}`
}

export const formatRaceDateTime = (datetime: Date) : string => {
  if (!(datetime instanceof Date)) return ''
  let year = datetime.getFullYear(),
    month = datetime.getMonth() + 1,
    date = datetime.getDate(),
    hour = datetime.getHours(),
    minute = datetime.getMinutes(),
    second = datetime.getSeconds()
  return `${('00' + month).substr(-2)}/${('00' + date).substr(-2)} ${('00' + hour).substr(-2)}:${('00' + minute).substr(-2)}`
}

